import { render, staticRenderFns } from "./BerlinLevel.vue?vue&type=template&id=8355f0f8&scoped=true&"
import script from "./BerlinLevel.vue?vue&type=script&lang=js&"
export * from "./BerlinLevel.vue?vue&type=script&lang=js&"
import style0 from "./BerlinLevel.vue?vue&type=style&index=0&id=8355f0f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8355f0f8",
  null
  
)

export default component.exports